module.exports = __webpack_public_path__ + "static/media/heatmapOverlay.b2ee0142.png";